import { render } from "./MainLayoutInstitute.vue?vue&type=template&id=54b4a78c&scoped=true"
import script from "./MainLayoutInstitute.vue?vue&type=script&lang=js"
export * from "./MainLayoutInstitute.vue?vue&type=script&lang=js"

import "./MainLayoutInstitute.vue?vue&type=style&index=0&id=54b4a78c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b4a78c"]])

export default __exports__